import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Tab from "react-bootstrap/Tab";
import "./Admin.css";
import { Col, Modal, Row } from "react-bootstrap";
import axios from "axios";
import AdminSideBar from "./AdminSideBar";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";

function AdminCategorias() {
  const [modalBorrar, setModalBorrar] = useState(false);
  const [modalCategoria, setmodalCategoria] = useState(false);
  const [modalEditar, setModalEditar] = useState(false);
  const user = useSelector((state) => state.user_auth);

  const [newCategory, setNewCategory] = useState("");
  const [catName, setCatName] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [contador, setContador] = useState(0);
  const [editCatName, setEditCatName] = useState("");

  const [categories, setCategories] = useState([]);

  let delayInMilliseconds = 500;
  const deleteCategory = async () => {
    const deleteCategoryURL = process.env.REACT_APP_API_URL + `/admin/categories/${categoryId}`;
    try {
      const response = await axios({
        method: "DELETE",
        url: deleteCategoryURL,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });
      if (response.status === 200) {
        toast.info(`${response.data.message}`, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setTimeout(function () {
          setContador(contador + 1);
        }, delayInMilliseconds);
        setNewCategory("");
      }
    } catch (error) {
      toast.error(`Error : ` + error, {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  const postCategory = async () => {
    const postCategoryURL = process.env.REACT_APP_API_URL + `/admin/categories`;
    try {
      if (newCategory !== "") {
        const response = await axios({
          method: "POST",
          url: postCategoryURL,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
          data: { name: newCategory },
        });
        if (response.status === 200) {
          toast.info(`${response.data.message}`, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setNewCategory("");
          setTimeout(function () {
            setContador(contador + 1);
          }, delayInMilliseconds);
        }
      } else {
        toast.error(`La categoria no puede estar vacia!`, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      console.log(error);
      toast.error(`Error : ` + error, {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const updateCategory = async (e) => {
    e.preventDefault();
    console.log("ESTE EL EL TOKEN : ", user.token);
    const url = process.env.REACT_APP_API_URL + "/admin/categories/" + categoryId;
    try {
      const response = await axios({
        method: "PATCH",
        url: url,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        data: {
          name: editCatName,
        },
      });
      if (response.status === 200) {
        toast.info("Categoría editada con éxito!", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setTimeout(function () {
          setContador(contador + 1);
        }, delayInMilliseconds);
        setEditCatName("");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const categoriesURL = process.env.REACT_APP_API_URL + `/categories`;

    const fetchCategoriesData = async () => {
      const categoriesData = await axios({
        method: "GET",
        url: categoriesURL,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });
      setCategories(categoriesData.data);
    };
    fetchCategoriesData();
  }, [contador]);

  return (
    <div id="twc-admin">
      <div className="container">
        <Tab.Container id="left-tabs-example" defaultActiveKey="second">
          <Row className="mt-6 mb-5">
            <Col sm={2} className="d-flex flex-column">
              <AdminSideBar />
              <button
                type="button"
                className="btn btn-success d-flex justify-content-center align-items-center mt-5"
                onClick={() => setmodalCategoria(true)}
              >
                Agregar Categoria
              </button>
            </Col>
            <Col sm={10}>
              <Tab.Content>
                <Tab.Pane eventKey="second">
                  <div className="shadow p-4 border border-dark rounded admin-table">
                    {categories.length !== 0 ? (
                      <table className="table table-light table-striped table-hover">
                        <thead>
                          <tr>
                            <th scope="col">Nombre</th>
                            <th scope="col">ID</th>
                            <th scope="col"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {categories.map((category) => (
                            <tr key={category._id}>
                              <th scope="row">{category.name}</th>
                              <td>{category._id}</td>
                              <td>
                                <div className="d-flex align-items-center justify-content-center">
                                  <button
                                    type="button"
                                    className="btn btn-warning btnAdmin d-flex justify-content-center align-items-center"
                                    onClick={() => {
                                      setCategoryId(category._id);
                                      setCatName(category.name);
                                      setModalEditar(true);
                                    }}
                                  >
                                    <i className="far fa-edit"></i>
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-danger btnAdmin d-flex justify-content-center align-items-center ms-1"
                                    onClick={() => {
                                      setCategoryId(category._id);
                                      setModalBorrar(true);
                                    }}
                                  >
                                    <i className="fas fa-times"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <div className="d-flex justify-content-center text-center align-items-center">
                        <Spinner animation="border" role="status"></Spinner>
                        <span className="ms-1">Loading...</span>
                      </div>
                    )}
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </div>
      {/* MODAL BORRAR  */}
      <Modal show={modalBorrar} onHide={() => setModalBorrar(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar</Modal.Title>
        </Modal.Header>
        <Modal.Body>¿Estás seguro de que querés eliminar esto?</Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => {
              deleteCategory();
              setModalBorrar(false);
            }}
          >
            Borrar
          </button>

          <button type="button" className="btn btn-secondary" onClick={() => setModalBorrar(false)}>
            Cancelar
          </button>
        </Modal.Footer>
      </Modal>
      {/* MODAL AGREGAR CATEGORIA  */}
      <Modal show={modalCategoria} onHide={() => setmodalCategoria(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar categoria</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="mb-2">
              <label htmlFor="nombreCat" className="form-label">
                Nombre
              </label>
              <input
                type="text"
                className="form-control"
                id="nombreCat"
                onChange={(ev) => {
                  setNewCategory(ev.target.value);
                }}
              />
            </div>
            <div className="d-flex  justify-content-end">
              <button
                type="button"
                className="btn btn-success"
                onClick={() => {
                  postCategory();
                  setmodalCategoria(false);
                }}
              >
                Agregar
              </button>
              <button
                type="button"
                className="btn btn-secondary ms-2"
                onClick={() => setmodalCategoria(false)}
              >
                Cancelar
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <Modal show={modalEditar} onHide={() => setModalEditar(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Editar producto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={(e) => {
              updateCategory(e);
              setmodalCategoria(false);
            }}
          >
            <div className="mb-2">
              <label htmlFor="exampleInputEmail1" className="form-label">
                Nombre
              </label>
              <input
                type="text"
                className="form-control"
                value={catName}
                id="exampleInputEmail1"
                onChange={(e) => {
                  setEditCatName(e.target.value);
                  setCatName(e.target.value);
                }}
              />
            </div>

            <div className="d-flex  justify-content-end">
              <button
                type="sumbit"
                className="btn btn-success"
                onClick={() => setModalEditar(false)}
              >
                Editar
              </button>

              <button
                type="button"
                className="btn btn-secondary ms-2"
                onClick={() => setModalEditar(false)}
              >
                Cancelar
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default AdminCategorias;
